import { useParams } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { TenantPathParams } from 'src/routes/path'
import { selectTenantByCode } from 'src/slices/tenants/tenantsSlice'
import { selectTenantSalesReportByParams } from 'src/slices/tenantSalesReports/tenantSalesReportsSlice'
import { useAppSelector } from 'src/store'

export type EventType = 'start' | 'skip' | 'next' | 'back' | 'finish'

const useBigQuery = (): {
  sendReportCheckEvent: (type: EventType) => void
} => {
  const { orgCode, storeCode, tenantCode } =
    useParams<TenantPathParams>() as TenantPathParams
  const tenant = useAppSelector(
    selectTenantByCode({ orgCode, storeCode, tenantCode })
  )
  const { selectedTenantIndex, selectedTenantCodes, date } = useAppSelector(
    (state) => state.forms.confirmSalesReport
  )

  const tenantSalesReport = useAppSelector(
    selectTenantSalesReportByParams({
      orgCode,
      storeCode,
      tenantCode,
      date,
    })
  )

  const sendReportCheckEvent = (type: EventType) => {
    const url =
      process.env.REACT_APP_ENV === 'production'
        ? 'https://asia-northeast1-zero-firebase-production.cloudfunctions.net/sendReportEvent'
        : 'https://asia-northeast1-zero-firebase-staging.cloudfunctions.net/sendReportEvent'

    const isStart = type === 'start'

    let transactionId = window.localStorage.getItem('transaction')
    if (transactionId === null) {
      transactionId = uuidv4()
      window.localStorage.setItem('transaction', transactionId)
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: transactionId,
        salesDate: date,
        tenantId: tenant?.id,
        orgCode,
        storeCode,
        tenantCode,
        registerCount: tenantSalesReport?.registers.length,
        stepBottom: selectedTenantCodes.length,
        stepTop: isStart ? 0 : selectedTenantIndex + 1,
        eventType: type,
      }),
    })

    if (type === 'finish') {
      window.localStorage.removeItem('transaction')
    }
  }

  return { sendReportCheckEvent }
}

export { useBigQuery }
